module.exports = __webpack_public_path__ + "static/wallet-8400af1ef776b07ac2291c01bea0cebb.svg";